import { render, staticRenderFns } from "./SchoolPickerSecretary.vue?vue&type=template&id=032bcb9c&"
import script from "./SchoolPickerSecretary.vue?vue&type=script&lang=js&"
export * from "./SchoolPickerSecretary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports